export default "__VITE_ASSET__B8e_SDtu__"